export const generateHtmlPdf = ({
	titleData = {},
	customTitleHtml = '',
	headers = [],
	data = [],
	appendTableRow = ''
}) => {
	const titleHtml =
		Object.entries(titleData).map(([key, value]) => value ? `<p>${key}: ${value}</p>` : '').join('');
	const headersHtml =
		headers.map(c => `<th class="header-text">${c}</th>`).join('');
	const dataHtml =
		data.map(item =>
			`<tr>
				${item.map(c => (typeof c === 'object' ? `<td style='${c.style}'> ${c.text}` : `<td> ${c}`) + '</td>').join('')}
			</tr>`
		).join('');
	const html = `
		<table>
			<thead>
				<tr>
					<th
						colspan="${headers.length}"
						class="fixed-header"
						style="padding-bottom: 8px;"
					>
						<div class="d-flex align-center justify-space-between">
							<img src="${require('@/assets/logo.png')}" width="128"/>
							<div>
								<p style="font-weight: 700;">Ugarit Co.</p>
								${titleHtml}
							</div>
						</div>
						${customTitleHtml}
					</th>
				</tr>
				<tr>
					${headersHtml}
				</tr>
			</thead>
			<tbody>
				${dataHtml}
				${appendTableRow}
			</tbody>
		</table>

		<style>
			* { font-family: 'Times New Roman', Times, serif !important; }
			p { margin: 0; text-align: start; }
			th { text-align: unset; }
			table { border-collapse: collapse; width: 100%; }
			th:not(.fixed-header) { background-color: #015931; color: white; }
			th:not(.fixed-header), td {
				border: 1px solid #333333;
				text-align: center;
				vertical-align: middle;
			}
			.fixed-header { font-size: 10pt; font-weight: 400; }
			.header-text { font-size: 10pt; font-weight: 600; }
			.d-flex { display: flex; }
			.align-center { align-items: center; }
			.justify-space-between { justify-content: space-between; }
			@page {
				size: A4;
				margin: 0.5cm;
				@bottom-right {
					content: counter(page) " / " counter(pages);
					font-size: 12px;
					color: #333;
				}
			}
		</style>
	`;
	return html;
}
